/**
 * Returns the input only if it is a same-origin path safe to use as a
 * post-login redirect target. Anything else (absolute URLs,
 * protocol-relative URLs, javascript:/data: schemes, control characters)
 * is rejected so a magic link cannot be turned into an open redirect.
 */
export function sanitizeRedirectPath(value: unknown): string | undefined {
  if (typeof value !== 'string' || value.length === 0 || value.length > 2048) {
    return undefined;
  }
  if (!value.startsWith('/')) {
    return undefined;
  }
  if (value.startsWith('//') || value.startsWith('/\\')) {
    return undefined;
  }
  // eslint-disable-next-line no-control-regex
  if (/[\x00-\x20\x7f]/.test(value)) {
    return undefined;
  }
  return value;
}
